import axios from "../../../context/axiosConfig";

const pozyczkiAddPromissoryNote = async ({ loanId, date, user }) => {
	return axios.post("/pozyczki/promissory/add", {
		loanId,
		date,
		user,
	});
};

export default pozyczkiAddPromissoryNote;
